import clsx from 'clsx'
import type { ComponentProps } from 'react'
import type { UiIconName } from '../icon/icon'
import { Icon } from '../icon/icon'
import { type IconButtonType, iconButtonStyle } from './icon-button.css'

type Props = {
  icon: UiIconName
  iconButtonType?: IconButtonType
}

export function IconButton({
  icon,
  iconButtonType,
  ...props
}: Props & ComponentProps<'button'>) {
  return (
    <button
      type="button"
      {...props}
      className={clsx(
        iconButtonStyle({ type: iconButtonType }),
        props.className,
      )}
    >
      <Icon icon={icon} size="sm" />
    </button>
  )
}
